// TODO: Import React module
import * as React from 'react';

// TODO: Import MUI module;
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';

// TODO: Import MUI icon;

// TODO: Import custom component
import { FetchData } from '../common/common.js';

export default function BoxFirst() {
    // TODO: Define useContext

    // TODO: Define variable
    const [checked, setChecked] = React.useState(false);
    const [items, setItems] = React.useState([]);
    const [itemIndex1, setItemIndex1] = React.useState(-1);
    const [itemIndex2, setItemIndex2] = React.useState(-1);
    const fadeTime = 5000;

    // TODO: Define event
    React.useEffect(() => {
        const formData = new FormData();
        formData.append('action', 'GetBanner');

        FetchData(
            'https://www.pohtyh.edu.hk/YiYuan/webservices.php',
            formData,
            ((result) => { setItems(result); })
        );

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        if (items.length > 0) {
            setItemIndex1(0);
        }
    }, [items]);

    React.useEffect(() => {
        if (itemIndex1 >= 0) {
            // TODO: Init itemIndex2
            if (items.length > 1 && itemIndex2 === -1) {
                //setItemIndex2(1);
            }

            // TODO: Show item1
            setChecked((prev) => !prev);

            // TODO: Hide item1
            setTimeout(() => {
                setChecked((prev) => !prev);
            }, fadeTime);

            // TODO: Set next index for item1
            setTimeout(() => {
                const idx1 = itemIndex1;
                setItemIndex1(idx1 + 2 >= items.length ? idx1 + 2 - items.length : idx1 + 2);
            }, fadeTime * 2);

            // TODO: Set next index for item2
            setTimeout(() => {
                const idx2 = itemIndex2;
                setItemIndex2(idx2 + 2 >= items.length ? idx2 + 2 - items.length : idx2 + 2);
            }, 1000);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [itemIndex1]);

    // TODO: Define function

    // TODO: Return component
    return (
        <Container sx={{ height: `calc(100vw * 9 / 16)` }}>
            {
                items.length > 0 &&
                itemIndex2 >= 0 &&
                <Box
                    sx={{
                        alignItems: 'center',
                        backgroundImage: `url("https://www.pohtyh.edu.hk/YiYuan/images/banner/${items[itemIndex2]['Image']}")`,
                        backgroundSize: 'cover',
                        display: 'flex',
                        height: `calc(100vw * 9 / 16)`,
                        justifyContent: 'center',
                        left: 0,
                        position: 'absolute',
                        top: 0,
                        width: '100%',
                    }}
                >
                    <Typography
                        component="p"
                        gutterBottom
                        sx={{
                            color: '#FFF',
                            fontWeight: 'bold',
                            fontSize: { xs: '2.5rem', md: '6rem' },
                            textShadow: '0px 0px 10px #000',
                        }}
                        variant="h1"
                    >
                        {itemIndex2 >= 0 && items[itemIndex2]['Slogan']}
                    </Typography>
                </Box>
            }
            {
                items.length > 0 &&
                itemIndex1 >= 0 &&
                <Fade
                    in={checked}
                    timeout={{
                        enter: 1000,
                        exit: 1000
                    }}
                >
                    <Box
                        sx={{
                            alignItems: 'center',
                            backgroundImage: `url("https://www.pohtyh.edu.hk/YiYuan/images/banner/${items[itemIndex1]['Image']}")`,
                            backgroundSize: 'cover',
                            display: 'flex',
                            height: `calc(100vw * 9 / 16)`,
                            justifyContent: 'center',
                            left: 0,
                            position: 'absolute',
                            top: 0,
                            width: '100%',
                        }}
                    >
                        <Typography
                            component="p"
                            gutterBottom
                            sx={{
                                color: '#FFF',
                                fontWeight: 'bold',
                                fontSize: { xs: '2.5rem', md: '6rem' },
                                textShadow: '0px 0px 10px #000',
                            }}
                            variant="h1"
                        >
                            {itemIndex1 >= 0 && items[itemIndex1]['Slogan']}
                        </Typography>
                    </Box>
                </Fade>
            }
        </Container>
    );
}